import {ARROW_KEY_STEP, ARROW_KEY_STEP_LARGE} from "./constants"
import {roundToGrid} from "../../services/gridUtils"

export interface ArrowKeyParams {
    canvasId: string
    widgets: Array<{id: string, left: number, top: number}>
    canvasSelection: Array<string>
    key: string
    shiftKey: boolean
    alignToGrid?: boolean
    moveWidgets: (canvasId: string, positions: Array<{id: string, left: number, top: number}>, alignToGrid?: boolean) => void
}

export const processArrowKey = ({
    canvasId,
    widgets,
    canvasSelection,
    key,
    shiftKey,
    alignToGrid,
    moveWidgets,
}: ArrowKeyParams): boolean => {
    const step = shiftKey ? ARROW_KEY_STEP_LARGE : ARROW_KEY_STEP

    let newLeft: number | undefined
    let newTop: number | undefined

    switch (key) {
        case 'ArrowUp':
            newTop = -step
            break
        case 'ArrowDown':
            newTop = step
            break
        case 'ArrowLeft':
            newLeft = -step
            break
        case 'ArrowRight':
            newLeft = step
            break
        default:
            return false
    }

    const selectedWidgets = widgets.filter(w => canvasSelection.includes(w.id))

    const positions = selectedWidgets.map(widget => {
        const left = newLeft !== undefined ? Math.max(0, widget.left + newLeft) : widget.left
        const top = newTop !== undefined ? Math.max(0, widget.top + newTop) : widget.top
        return {
            id: widget.id,
            left: alignToGrid ? roundToGrid(left) : left,
            top: alignToGrid ? roundToGrid(top) : top,
        }
    })

    moveWidgets(canvasId, positions, alignToGrid)
    return true
}
